'use client';

import { useEffect, useState } from 'react';
import { SwiperSlide } from 'swiper/react';

import { useMediaType } from '@/app/lib/hooks/use-media-type';

import { Carousel } from '../../carousel';
import { ReviewCard } from '../../review-card';

import type { ReviewBlock } from '@/app/generated/graphql';

export const ReviewListing = ({
  reviewsCollection,
}: {
  reviewsCollection: ReviewBlock['reviewsCollection'];
}) => {
  const { isDesktop, isTablet, isMobile } = useMediaType();

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) return null;

  if (reviewsCollection) {
    if (isMobile) {
      return (
        <Carousel
          slidesPerView={1.05}
          centeredSlides={false}
          spaceBetween={8}
          className="flex-end review-slider"
        >
          {reviewsCollection.items.map((item) => {
            if (!item) {
              return null;
            }
            return (
              <SwiperSlide key={item.sys.id}>
                <div className="h-full">
                  <ReviewCard {...item} />
                </div>
              </SwiperSlide>
            );
          })}
        </Carousel>
      );
    } else if (isDesktop || isTablet) {
      return (
        <div className="mb-e flex flex-wrap items-stretch justify-center gap-a">
          {reviewsCollection.items.map((item) => {
            if (!item) {
              return null;
            }

            return (
              <div
                className="flex w-[31%] flex-col self-stretch"
                key={item.sys.id}
              >
                <ReviewCard {...item} />
              </div>
            );
          })}
        </div>
      );
    }
  }
};
